"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyOfAttributeParser = anyOfAttributeParser;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const cloneDeep_js_1 = require("../../../utils/cloneDeep.js");
const attribute_js_1 = require("./attribute.js");
const utils_js_1 = require("./utils.js");
function* anyOfAttributeParser(attribute, inputValue, options = {}) {
    const { fill = true, transform = true, valuePath = [] } = options;
    let parser = undefined;
    let _defaultedValue = undefined;
    let _linkedValue = undefined;
    let _parsedValue = undefined;
    for (const elementAttribute of attribute.elements) {
        try {
            parser = (0, attribute_js_1.attrParser)(elementAttribute, inputValue, options);
            if (fill) {
                _defaultedValue = parser.next().value;
                // Note: Links cannot be used in anyOf elements or sub elements for this reason (we need the return of the yield)
                _linkedValue = parser.next().value;
            }
            _parsedValue = parser.next().value;
            break;
        }
        catch (error) {
            parser = undefined;
            _defaultedValue = undefined;
            _linkedValue = undefined;
            _parsedValue = undefined;
            continue;
        }
    }
    if (fill) {
        const defaultedValue = _defaultedValue !== null && _defaultedValue !== void 0 ? _defaultedValue : (0, cloneDeep_js_1.cloneDeep)(inputValue);
        yield defaultedValue;
        const linkedValue = _linkedValue !== null && _linkedValue !== void 0 ? _linkedValue : defaultedValue;
        yield linkedValue;
    }
    const parsedValue = _parsedValue;
    if (parser === undefined || parsedValue === undefined) {
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('parsing.invalidAttributeInput', {
            message: `Attribute${path !== undefined ? ` '${path}'` : ''} does not match any of the possible sub-types.`,
            path,
            payload: { received: inputValue }
        });
    }
    if (parsedValue !== undefined) {
        (0, utils_js_1.applyCustomValidation)(attribute, parsedValue, options);
    }
    if (transform) {
        yield parsedValue;
    }
    else {
        return parsedValue;
    }
    const transformedValue = parser.next().value;
    return transformedValue;
}
